/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';

import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';
import { apiConfig } from '@pages/AdminPage/config/api.config';
import { deleteUserConfig } from '@pages/AdminPage/config/deleteUser.config';
import { DELETE_USER } from '@pages/AdminPage/api/graphql';
import { notificationUserConfig } from '../../config/notifications.config';

const getWhoamiSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface IDeleteUserPluginMethods extends IPluginMethodMap {
  getDeleteUserSync(args?: any): any;
}

export class DeleteUserPlugin implements IAgentPlugin {
  readonly methods: IDeleteUserPluginMethods;

  constructor() {
    this.methods = {
      getDeleteUserSync: this.getDeleteUserSync.bind(this),
    };
  }

  async getDeleteUserSync(args?: any) {
    await new Promise((r) => setTimeout(r, 2000));
    await this.deleteUser();
    //   return {
    //     delete:deleteUserConfig
    //  };
  }

  //Graphql Query example
  async deleteUser(args?: any) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    const token = getWhoamiSrv()?.getToken();
    //const token = null;
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        const res = await client
          .mutation(DELETE_USER, {
            vuid: args,
          })
          .toPromise();
        if (res?.data) {
          return {
            ...res?.data?.removeUser,
            notification: notificationUserConfig?.deleteUserSuccess,
          };
        }
      }
    } catch (err: any) {
      // log.log('result of update profile=', res?.data?.capsules);
      log.error('error in activate User', err?.message);
      throw err;
    }
  }
}
